export default __webpack_public_path__ + "static/media/moderator-lekalo-icon.150f9239.svg";